import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SJPBSearchCom} from '../containers'
function SJPBSearchComPage() {
    //we are inet so id is not passed
    console.log('SV*****SJPBSearchComPage')
    let { id } = useParams();
    let svparams = { 'id': id}

    console.log('SV*****SJPBSearchComPage',svparams)
    
    return (
        <SJPBSearchCom svparams={svparams} ></SJPBSearchCom>
        
    );
}
export default SJPBSearchComPage